import { render } from "./CreateCertificate.vue?vue&type=template&id=08ded613"
import script from "./CreateCertificate.vue?vue&type=script&lang=js"
export * from "./CreateCertificate.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__